import React, { useContext, useMemo } from "react";
import { useTheme as useThemeV4 } from "@material-ui/core/styles";
import {
  createTheme as createThemeV5,
  ThemeProvider as ThemeProviderV5,
} from "@mui/material/styles";
import { Box } from "@mui/material";

import MomentsUser from "../../components/MomentsUser";
import ForbiddenPage from "../../components/ForbiddenPage";
import { AuthContext } from "../../context/Auth/AuthContext";

const ChatMoments = () => {
  const themeV4 = useThemeV4();
  const { user } = useContext(AuthContext);

  const isDark = (themeV4?.palette?.type || themeV4?.mode) === "dark";
  const PRIMARY_MAIN = themeV4?.palette?.primary?.main || "#1976d2";
  const PRIMARY_DARK = themeV4?.palette?.primary?.dark || "#115293";
  const PRIMARY_CONTRAST = themeV4?.palette?.primary?.contrastText || "#fff";

  const v5Theme = useMemo(
    () =>
      createThemeV5({
        palette: {
          mode: isDark ? "dark" : "light",
          primary: { main: PRIMARY_MAIN, dark: PRIMARY_DARK, contrastText: PRIMARY_CONTRAST },
          background: {
            default: isDark ? "#121212" : "#ffffff",
            paper: isDark ? "#0b0d12" : "#ffffff",
          },
          divider: isDark ? "rgba(255,255,255,0.10)" : "rgba(15,23,42,0.10)",
        },
        components: {
          MuiOutlinedInput: { styleOverrides: { root: { borderRadius: 12 } } },
          MuiButton: { styleOverrides: { root: { borderRadius: 12 } } },
        },
      }),
    [isDark, PRIMARY_MAIN, PRIMARY_DARK, PRIMARY_CONTRAST]
  );

  if (user.profile === "user" && user.allowRealTime === "disabled") {
    return <ForbiddenPage />;
  }

  return (
    <ThemeProviderV5 theme={v5Theme}>
      <Box
        sx={{
          background: isDark ? "#121212" : "#ffffff",
          height: "100%",
          width: "100%",
          paddingTop: "12px",
          paddingBottom: "12px",
          paddingLeft: "12px",
          paddingRight: 0,
          overflow: "hidden",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Box
          sx={{
            flex: 1,
            minHeight: 0,
            overflow: "auto",
            paddingRight: "12px",
            ...(themeV4.scrollbarStyles || {}),
          }}
        >
          <MomentsUser />
        </Box>
      </Box>
    </ThemeProviderV5>
  );
};

export default ChatMoments;
